import { gql } from '@apollo/client';

export const ALL_AUDIENCE_TYPES = gql`
  query AllAudienceTypes {
    audienceTypes: getAudienceTypes {
      id
      name
    }
  }
`;
